export const captainBillingUrl = (clientId: string, path: string) => `/api/v2/Clients/${clientId}/Captain/Billing/${path}`;
